import React from 'react'
import Modal from 'react-modal'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import CommError from '../../Shared/Errors/Errors'

import './CreateEditTemplate.css'
import { isNull } from 'util';

const styling = {
    content: {
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        maxWidth: 'none',
        paddingTop: '0px',
        background: 'white',
        paddingLeft: '50px',
        paddingRight: '40px'
    }
}

const styling2 = {
    content: {
        top: '80px',
        left: '0px',
        width: '60%',
        height: '50%',
        maxWidth: 'none',
        paddingTop: '0px',
        background: 'white',
        paddingLeft: '50px',
        paddingRight: '40px'
    }
}

const CreateEditTemplate = (
    {
        errTemplate,
        errTemplateClear,

        seriesList,

        curTemplate,
        tmpTemplate,

        create,
        isOpen,

        onAfterOpen,

        showFilterProducts,
        closeFilterProducts,

        onRequestImport,
        onRequestExport,
        onRequestClose,
        onRequestCancel,

        onImport,

        onSeries,
        onChange,
        onChange2,

        tooltipEnter,
        tooltipLeave,

        filter,
        filterErr,
        validateSQL,
        productsWithDifferentTemplateId,

        calculateProductGroupCount,
        productGroupCount,

        formulas,
        formulaValidate,

        canPublish,
        canDraft
    }) => (
        <Modal isOpen={isOpen} onAfterOpen={onAfterOpen} onRequestClose={onRequestClose} style={styling}>
            <CommError error={errTemplate.error} onClose={errTemplateClear} />

            <input id="fileChooseButtonTemplate" type="file" onChange={onImport} accept=".xlsx" />

            <div className="create-edit-template editpages">
                <h1>{create ? 'Edit' : 'Create'} Product Template</h1>
                <p className="sublabel">A product template defines a group of product, the Reico SKU Class, the epi Category and all of the field defaults for the published (epi) products.</p>
                <div className="edittemplate">
                    <div className="form-group">
                        <div className="hdr pull-right">
                        <a className="btn btn-info" onClick={onRequestCancel}>Cancel</a>&nbsp;
                        {
                        !create ?
                            <button className="btn btn-primary template import hdr" disabled>Import</button>
                        :
                            <button className="btn btn-primary template import hdr" template={curTemplate.productTemplateId} onClick={onRequestImport}>Import</button>
                        }
                        {
                            !create ?
                                <button className="btn btn-primary template export hdr" disabled>Export</button>
                            :
                                <button className="btn btn-primary template export hdr" template={curTemplate.productTemplateId} onClick={onRequestExport}>Export</button>
                        }
                        {
                            !canDraft ||
                            filterErr ||
                            filter == null ||
                            filter.productCount === 0 ?
                                <button className="btn template draft hdr" disabled create={create ? "false" : "true"} draft="true" published={create ? curTemplate.published : tmpTemplate.published}>Save As Draft</button>
                            :
                                <button className="btn template draft hdr" create={create ? "false" : "true"} draft="true" published={create ? curTemplate.published : tmpTemplate.published} onClick={onRequestClose}>Save As Draft</button>
                        }
                        {
                            !canPublish ||
                            filterErr ||
                            filter == null ||
                            filter.productCount === 0 ||
                            productsWithDifferentTemplateId.length > 0 ||

                            formulas.groupCode && !formulas.groupCode.formulaEvaluationSuccess ||
                            formulas.groupName && !formulas.groupName.formulaEvaluationSuccess ||
                            formulas.groupURL && !formulas.groupURL.formulaEvaluationSuccess ||
                            formulas.groupSETitle && !formulas.groupSETitle.formulaEvaluationSuccess ||
                            formulas.groupSEDescription && !formulas.groupSEDescription.formulaEvaluationSuccess ||
                            formulas.groupActive && !formulas.groupActive.formulaEvaluationSuccess ||                                    
                            formulas.groupStartDate && !formulas.groupStartDate.formulaEvaluationSuccess ||
                            formulas.groupEndDate && !formulas.groupEndDate.formulaEvaluationSuccess ||
                            formulas.groupMappedToReicoSite && !formulas.groupMappedToReicoSite.formulaEvaluationSuccess ||
                            formulas.groupMappedToDistributorSite && !formulas.groupMappedToDistributorSite.formulaEvaluationSuccess ||
                            formulas.code && !formulas.code.formulaEvaluationSuccess ||
                            formulas.name && !formulas.name.formulaEvaluationSuccess ||
                            formulas.active && !formulas.active.formulaEvaluationSuccess ||
                            formulas.startDate && !formulas.startDate.formulaEvaluationSuccess ||
                            formulas.endDate && !formulas.endDate.formulaEvaluationSuccess ||
                            formulas.showQuoteButton && !formulas.showQuoteButton.formulaEvaluationSuccess ||
                            formulas.showBuyButton && !formulas.showBuyButton.formulaEvaluationSuccess ||
                            formulas.hidePriceUntilCart && !formulas.hidePriceUntilCart.formulaEvaluationSuccess ||
                            formulas.minimumQty && !formulas.minimumQty.formulaEvaluationSuccess ||
                            formulas.maximumQty && !formulas.maximumQty.formulaEvaluationSuccess ||
                            formulas.inStockQuantity && !formulas.inStockQuantity.formulaEvaluationSuccess ?

                                <button className="btn btn-primary template publish hdr" disabled create={create ? "false" : "true"}>Publish</button>
                            :
                                <button className="btn btn-primary template publish hdr" create={create ? "false" : "true"} onClick={onRequestClose}>Publish</button>
                        }
                        </div>
                    </div>
                    <p>*=Required for publishing</p>
                    {create ?
                        <div className="form-group opts">
                            <label>ProductTemplateID:</label>
                            <span id="template_id">{create ? curTemplate.productTemplateId : null}</span>
                        </div> : null
                    }
                    <div className="form-group opts">
                        <label>Name:*</label>
                        <input id="template_name" className="form-control template" published={create ? curTemplate.published : tmpTemplate.published} defaultValue={create ? curTemplate.name : tmpTemplate.name} onChange={onChange} />
                    </div>

                    {
                        create && filter && filter.products.filter(prod => prod.productTemplateId != curTemplate.productTemplateId).length ?
                            <Modal isOpen={showFilterProducts} onRequestClose={onRequestClose} style={styling2}>
                                <h1>Products with a different Template ID</h1>
                                <hr />

                                <table style={{ marginLeft: '16px' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '20%', paddingBottom: '12px' }}>AS400ProductID</th>
                                            <th style={{ width: '71%', paddingBottom: '12px' }}>Name</th>
                                            <th style={{ paddingBottom: '12px' }}>Template ID</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            productsWithDifferentTemplateId.map(prod =>
                                                <tr>
                                                    <td>{prod.aS400ProductId}</td>
                                                    <td>{prod.name}</td>
                                                    <td>{prod.productTemplateId}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>

                                <button className="btn btn-primary" style={{ float: 'right', marginTop: '100px' }} onClick={closeFilterProducts}>Close</button>
                            </Modal>
                        : null
                    }

                    <div className="form-group opts">
                        <label>Product Filter:*
                            <span className="icons">
                                <OverlayTrigger placement="top" overlay={<Tooltip>SQL Example - [BRMFG]='BAL' AND [BRLIN] in ('MA','RO')</Tooltip>}>
                                    <i className="fa fa-info-circle"></i>
                                </OverlayTrigger>
                            </span>
                        </label>
                        <textarea className="form-control" id="template_filter" spellCheck="false" defaultValue={create ? curTemplate.filter : tmpTemplate.filter} onChange={onChange} onBlur={validateSQL} />
                        {
                            filter && filter.productCount >= 0 ?
                                <div>
                                    <div className="eval">
                                        <button class="btn btn-primary" onClick={validateSQL}>
                                            Evaluate
                                        </button>
                                    </div>
                                    <div className="eval">
                                        <p>{filter.productCount} products returned</p>
                                    </div>
                                </div>
                            :
                                filterErr ?
                                    filter && filter.message ?
                                        <p className="err">{filter.message}</p>
                                    :
                                        <p className="err">An error has occurred on the server. Please contact support team so that it can be investigated</p>
                                :
                                    null
                        }
                    </div>
                    <div className="form-group opts">
                        <label>Web Category 1:*</label>
                        {
                            errTemplate.categories.length === 0 ?
                                <span className="err">An error has occurred on the server. Please contact support team so that it can be investigated</span>
                            :
                                null
                        }
                        {
                            errTemplate.categories.length === 0 ?
                                <select className="form-control web1" disabled defaultValue="Select">
                                    <option noselect="true">Select</option>
                                </select>
                            :
                                <select className="form-control web1" defaultValue="Select" onChange={onChange}>
                                    <option noselect="true">Select</option>
                                    {
                                        errTemplate.categories.map((opt, index) => {
                                            return <option value={opt.code} key={index}>{opt.name}</option>
                                        })
                                    }
                                </select>
                        }
                    </div>
                    <div className="form-group opts">
                        <label>Web Category 2:</label>
                        {
                            errTemplate.categories.length == 0 ?
                                <span className="err">An error has occurred on the server. Please contact support team so that it can be investigated</span>
                            :
                                null
                        }
                        {
                            errTemplate.categories.length === 0 ?
                                <select className="form-control web2" disabled defaultValue="Select">
                                    <option noselect="true">Select</option>
                                </select>
                            :
                                <select className="form-control web2" defaultValue="Select">
                                    <option noselect="true">Select</option>
                                    {
                                        errTemplate.categories.map((opt, index) => {
                                            return <option value={opt.code} key={index}>{opt.name}</option>
                                        })
                                    }
                                </select>
                        }
                    </div>
                    <div className="form-group opts">
                        <label>Product Series:*</label>  
                        {
                            seriesList.length == 0 ?
                                <span className="err">An error has occurred on the server. Please contact support team so that it can be investigated</span>
                            :
                                null
                        }
                        <select className="form-control series" onChange={onSeries} >
                            {
                                seriesList.map((opt, index) => {
                                    return opt.published ?
                                        <option value={opt.productSeriesId} key={index}>{opt.name}</option>
                                    :
                                        null
                                })
                            }
                        </select>                      
                    </div>
                    <div className="form-group opts">
                        <label>Group Meta Class Name:*</label>
                        <select className="form-control grpmeta" onChange={onChange} >
                            <option value="BaseProductContent">BaseProductContent</option>
                        </select>
                    </div>
                    <div className="form-group opts">
                        <label>Meta Class Name:*</label>
                        <select className="form-control meta" onChange={onChange} >
                            <option value="BaseVariationContent">BaseVariationContent</option>
                        </select>
                    </div>
                    <div className="form-group opts">
                        <label>Page Layout:*</label>
                        <select className="form-control layout" onChange={onChange} >
                            <option value="colorpicker">colorpicker</option>
                            <option value="dropdown">dropdown</option>
                            <option value="cabinetstyle">cabinetstyle</option>
                            <option value="colordropdown">colordropdown</option>
                        </select>
                    </div>
                    <div className="form-group opts">
                        <label>Language:*</label>
                        <div>
                            <label className="radio-inline">
                                <input type="radio" id="lang" checked readOnly />
                                English                                    
                            </label>
                        </div>
                    </div>
                </div>
                
                <div id="formula">
                    <span id="formula-hdr">English</span>
                    <table>
                        <tbody>
                            <tr>
                                <th className="name formula-hdr" style={{ minWidth: "220px" }}></th>
                                <th className="formula formula-hdr" style={{ minWidth: "430px" }}>Formula:</th>
                                <th className="sample formula-hdr">First Sample:</th>
                            </tr>
                            <tr>
                                <td className="name"><label>Group Code (txt):*</label></td>
                                <td className="formula">
                                    <textarea className="form-control" spellCheck="false" name="groupCode" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={(create ? curTemplate : tmpTemplate).productTemplateLanguages[0].groupCode} onChange={onChange2} onBlur={formulaValidate} />

                                    <p id="groupProductCountLabel" style={{ display:'flex', alignItems: 'center', marginTop: '10px' }}>
                                        <button class="btn btn-primary" id="calculateProductGroupCountBtn"
                                            onClick={calculateProductGroupCount}
                                            style={{ float: 'left', marginRight: '10px' }}
                                            disabled={filter
                                                && filter.productCount
                                                && formulas.groupCode 
                                                && formulas.groupCode.formulaEvaluationSuccess
                                                && formulas.groupCode.formulaExpression.trim()
                                                ? "" : "disabled"}>
                                            Calculate Product Count
                                        </button>
                                        {productGroupCount != null ? productGroupCount : ""}
                                    </p>
                                </td>
                                <td className="sample">
                                    {
                                        formulas.groupCode ?
                                            formulas.groupCode.formulaEvaluationSuccess ?
                                                <p>{formulas.groupCode.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.groupCode.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Group Name (txt):*</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="groupName" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].groupName} onChange={onChange2} onBlur={formulaValidate} />
                                            :
                                            <textarea className="form-control" spellCheck="false" name="groupName" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].groupName} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.groupName ?
                                            formulas.groupName.formulaEvaluationSuccess ?
                                                <p>{formulas.groupName.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.groupName.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Group Description (txt):</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="groupDescription" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].groupDescription} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="groupDescription" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].groupDescription} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.groupDescription ?
                                            formulas.groupDescription.formulaEvaluationSuccess ?
                                                <p>{formulas.groupDescription.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.groupDescription.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Group URL (txt):*</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="groupURL" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].groupURL} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="groupURL" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].groupURL} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.groupURL ?
                                            formulas.groupURL.formulaEvaluationSuccess ?
                                                <p>{formulas.groupURL.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.groupURL.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Group SE Title (txt):*</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="groupSETitle" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].groupSETitle} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="groupSETitle" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].groupSETitle} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.groupSETitle ?
                                            formulas.groupSETitle.formulaEvaluationSuccess ?
                                                <p>{formulas.groupSETitle.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.groupSETitle.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Group SE Description (txt):*</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="groupSEDescription" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].groupSEDescription} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="groupSEDescription" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].groupSEDescription} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.groupSEDescription ?
                                            formulas.groupSEDescription.formulaEvaluationSuccess ?
                                                <p>{formulas.groupSEDescription.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.groupSEDescription.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Group SE Keywords (txt):</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="groupSEKeywords" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].groupSEKeywords} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="groupSEKeywords" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].groupSEKeywords} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.groupSEKeywords ?
                                            formulas.groupSEKeywords.formulaEvaluationSuccess ?
                                                <p>{formulas.groupSEKeywords.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.groupSEKeywords.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Group Active (bln):*</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="groupActive" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].groupActive} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="groupActive" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].groupActive} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.groupActive ?
                                            formulas.groupActive.formulaEvaluationSuccess ?
                                                <p>{formulas.groupActive.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.groupActive.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Group Start (dte):*</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="groupStartDate" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].groupStartDate} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="groupStartDate" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].groupStartDate} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.groupStartDate ?
                                            formulas.groupStartDate.formulaEvaluationSuccess ?
                                                <p>{formulas.groupStartDate.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.groupStartDate.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Group End (dte):*</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="groupEndDate" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].groupEndDate} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="groupEndDate" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].groupEndDate} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.groupEndDate ?
                                            formulas.groupEndDate.formulaEvaluationSuccess ?
                                                <p>{formulas.groupEndDate.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.groupEndDate.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Group Mapped To Reico (txt):*</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="groupMappedToReicoSite" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].groupMappedToReicoSite} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="groupMappedToReicoSite" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].groupMappedToReicoSite} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.groupMappedToReicoSite ?
                                            formulas.groupMappedToReicoSite.formulaEvaluationSuccess ?
                                                <p>{formulas.groupMappedToReicoSite.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.groupMappedToReicoSite.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Group Mapped To Dist (txt):*</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="groupMappedToDistributorSite" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].groupMappedToDistributorSite} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="groupMappedToDistributorSite" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].groupMappedToDistributorSite} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.groupMappedToDistributorSite ?
                                            formulas.groupMappedToDistributorSite.formulaEvaluationSuccess ?
                                                <p>{formulas.groupMappedToDistributorSite.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.groupMappedToDistributorSite.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Code (txt)*:</label></td>
                                <td className="formula code">
                                    <textarea className="form-control" spellCheck="false" name="code" readOnly disabled={filter && filter.productCount > 0 ? "" : "disabled"}
                                        defaultValue={create ? curTemplate.productTemplateLanguages[0].code : tmpTemplate.productTemplateLanguages[0].code} />
                                </td>
                                <td className="sample">
                                    {
                                        formulas.code ?
                                            formulas.code.formulaEvaluationSuccess ?
                                                <p>{formulas.code.formulaResult}</p>

                                            :
                                                <p className="err">{formulas.code.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Name (txt):*</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="name" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].name} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="name" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].name} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.name ?
                                            formulas.name.formulaEvaluationSuccess ?
                                                <p>{formulas.name.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.name.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Description (txt):</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="description" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].description} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="description" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].description} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                 </td>
                                <td className="sample">
                                    {
                                        formulas.description ?
                                            formulas.description.formulaEvaluationSuccess ?
                                                <p>{formulas.description.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.description.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Active (bln):*</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="active" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].active} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="active" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].active} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.active ?
                                            formulas.active.formulaEvaluationSuccess ?
                                                <p>{formulas.active.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.active.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Start (dte):*</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="startDate" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].startDate} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="startDate" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].startDate} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.startDate ?
                                            formulas.startDate.formulaEvaluationSuccess ?
                                                <p>{formulas.startDate.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.startDate.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>End (dte):*</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="endDate" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].endDate} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="endDate" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].endDate} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.endDate ?
                                            formulas.endDate.formulaEvaluationSuccess ?
                                                <p>{formulas.endDate.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.endDate.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Manufacturer Part Number (txt):</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="manufacturerPartNumber" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].manufacturerPartNumber} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="manufacturerPartNumber" disabled={filter && filter.productCount > 0? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].manufacturerPartNumber} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.manufacturerPartNumber ?
                                            formulas.manufacturerPartNumber.formulaEvaluationSuccess ?
                                                <p>{formulas.manufacturerPartNumber.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.manufacturerPartNumber.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>GTIN (txt):</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="gtin" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].gtin} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="gtin" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].gtin} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.gtin ?
                                            formulas.gtin.formulaEvaluationSuccess ?
                                                <p>{formulas.gtin.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.gtin.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Override Image Base Name (txt):</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="overrideImageBaseName" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].overrideImageBaseName} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="overrideImageBaseName" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].overrideImageBaseName} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.overrideImageBaseName ?
                                            formulas.overrideImageBaseName.formulaEvaluationSuccess ?
                                                <p>{formulas.overrideImageBaseName.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.overrideImageBaseName.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Color Swatch (txt):</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="colorSwatch" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].colorSwatch} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="colorSwatch" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].colorSwatch} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.colorSwatch ?
                                            formulas.colorSwatch.formulaEvaluationSuccess ?
                                                <p>{formulas.colorSwatch.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.colorSwatch.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Swatch Image Name (txt):</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="swatchImageName" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].swatchImageName} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="swatchImageName" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].swatchImageName} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.swatchImageName ?
                                            formulas.swatchImageName.formulaEvaluationSuccess ?
                                                <p>{formulas.swatchImageName.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.swatchImageName.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Color Trait Name (txt):</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="colorTraitName" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].colorTraitName} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="colorTraitName" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].colorTraitName} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.colorTraitName ?
                                            formulas.colorTraitName.formulaEvaluationSuccess ?
                                                <p>{formulas.colorTraitName.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.colorTraitName.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Color Trait Value (txt):</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="colorTraitValue" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].colorTraitValue} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="colorTraitValue" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].colorTraitValue} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.colorTraitValue ?
                                            formulas.colorTraitValue.formulaEvaluationSuccess ?
                                                <p>{formulas.colorTraitValue.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.colorTraitValue.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Trait 1 Name (txt):</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="trait1Name" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].trait1Name} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="trait1Name" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].trait1Name} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.trait1Name ?
                                            formulas.trait1Name.formulaEvaluationSuccess ?
                                                <p>{formulas.trait1Name.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.trait1Name.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Trait 1 Value (txt):</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="trait1Value" disabled={filter && filter.productCount > 0 ? "" : "disabled"}  defaultValue={curTemplate.productTemplateLanguages[0].trait1Value} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="trait1Value" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].trait1Value} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                 </td>
                                <td className="sample">
                                    {
                                        formulas.trait1Value ?
                                            formulas.trait1Value.formulaEvaluationSuccess ?
                                                <p>{formulas.trait1Value.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.trait1Value.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Trait 2 Name (txt):</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="trait2Name" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].trait2Name} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="trait2Name" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].trait2Name} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.trait2Name ?
                                            formulas.trait2Name.formulaEvaluationSuccess ?
                                                <p>{formulas.trait2Name.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.trait2Name.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Trait 2 Value (txt):</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="trait2Value" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].trait2Value} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="trait2Value" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].trait2Value} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.trait2Value ?
                                            formulas.trait2Value.formulaEvaluationSuccess ?
                                                <p>{formulas.trait2Value.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.trait2Value.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Show Quote Button (bln):*</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="showQuoteButton" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].showQuoteButton} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="showQuoteButton" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].showQuoteButton} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.showQuoteButton ?
                                            formulas.showQuoteButton.formulaEvaluationSuccess ?
                                                <p>{formulas.showQuoteButton.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.showQuoteButton.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Show Buy Button (bln):*</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="showBuyButton" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].showBuyButton} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="showBuyButton" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].showBuyButton} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.showBuyButton ?
                                            formulas.showBuyButton.formulaEvaluationSuccess ?
                                                <p>{formulas.showBuyButton.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.showBuyButton.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Hide Price Until Cart (bln):*</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="hidePriceUntilCart" disabled={filter && filter.productCount > 0 ? "" : "disabled"}  defaultValue={curTemplate.productTemplateLanguages[0].hidePriceUntilCart} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="hidePriceUntilCart" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].hidePriceUntilCart} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.hidePriceUntilCart ?
                                            formulas.hidePriceUntilCart.formulaEvaluationSuccess ?
                                                <p>{formulas.hidePriceUntilCart.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.hidePriceUntilCart.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Min Quantity (int):*</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="minimumQty" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].minimumQty} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="minimumQty" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].minimumQty} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.minimumQty ?
                                            formulas.minimumQty.formulaEvaluationSuccess ?
                                                <p>{formulas.minimumQty.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.minimumQty.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Max Quantity (int):*</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="maximumQty" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].maximumQty} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="maximumQty" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].maximumQty} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.maximumQty ?
                                            formulas.maximumQty.formulaEvaluationSuccess ?
                                                <p>{formulas.maximumQty.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.maximumQty.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Stock Quantity (int):*</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="inStockQuantity" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].inStockQuantity} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="inStockQuantity" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].inStockQuantity} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.inStockQuantity ?
                                            formulas.inStockQuantity.formulaEvaluationSuccess ?
                                                <p>{formulas.inStockQuantity.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.inStockQuantity.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Weight (dec):</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="weight" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].weight} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="weight" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].weight} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.weight ?
                                            formulas.weight.formulaEvaluationSuccess ?
                                                <p>{formulas.weight.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.weight.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Regular Price (dec):</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="regularPrice" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].regularPrice} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="regularPrice" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].regularPrice} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.regularPrice ?
                                            formulas.regularPrice.formulaEvaluationSuccess ?
                                                <p>{formulas.regularPrice.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.regularPrice.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>Sale Price (dec):</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="salePrice" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].salePrice} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="salePrice" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].salePrice} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.salePrice ?
                                            formulas.salePrice.formulaEvaluationSuccess ?
                                                <p>{formulas.salePrice.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.salePrice.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>MSRP Price (dec):</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="msrpPrice" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].msrpPrice} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="msrpPrice" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].msrpPrice} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.msrpPrice ?
                                            formulas.msrpPrice.formulaEvaluationSuccess ?
                                                <p>{formulas.msrpPrice.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.msrpPrice.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="name"><label>MAP Price (dec):</label></td>
                                <td className="formula">
                                    {
                                        create ?
                                            <textarea className="form-control" spellCheck="false" name="mapPrice" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={curTemplate.productTemplateLanguages[0].mapPrice} onChange={onChange2} onBlur={formulaValidate} />
                                        :
                                            <textarea className="form-control" spellCheck="false" name="mapPrice" disabled={filter && filter.productCount > 0 ? "" : "disabled"} defaultValue={tmpTemplate.productTemplateLanguages[0].mapPrice} onChange={onChange2} onBlur={formulaValidate} />
                                    }
                                </td>
                                <td className="sample">
                                    {
                                        formulas.mapPrice ?
                                            formulas.mapPrice.formulaEvaluationSuccess ?
                                                <p>{formulas.mapPrice.formulaResult}</p>
                                            :
                                                <p className="err">{formulas.mapPrice.formulaResult}</p>
                                        : null
                                    }
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="form-group buttons template pull-right">
                    <a className="btn btn-info" onClick={onRequestCancel}>Cancel</a>&nbsp;
                    {
                        !canDraft ||
                        filterErr ||
                        filter == null ||
                        filter.productCount === 0 ?
                            <button className="btn template draft hdr" disabled create={create ? "false" : "true"} draft="true" published={create ? curTemplate.published : tmpTemplate.published}>Save As Draft</button>
                        :
                            <button className="btn template draft hdr" create={create ? "false" : "true"} draft="true" published={create ? curTemplate.published : tmpTemplate.published} onClick={onRequestClose}>Save As Draft</button>
                    }
                    &nbsp;
                    {
                        !canPublish ||
                        filterErr ||
                        filter == null ||
                        filter.productCount === 0 ||
                        productsWithDifferentTemplateId.length > 0 ||

                        formulas.groupCode && !formulas.groupCode.formulaEvaluationSuccess ||
                        formulas.groupName && !formulas.groupName.formulaEvaluationSuccess ||
                        formulas.groupURL && !formulas.groupURL.formulaEvaluationSuccess ||
                        formulas.groupSETitle && !formulas.groupSETitle.formulaEvaluationSuccess ||
                        formulas.groupSEDescription && !formulas.groupSEDescription.formulaEvaluationSuccess ||
                        formulas.groupActive && !formulas.groupActive.formulaEvaluationSuccess ||
                        formulas.groupStartDate && !formulas.groupStartDate.formulaEvaluationSuccess ||
                        formulas.groupEndDate && !formulas.groupEndDate.formulaEvaluationSuccess ||
                        formulas.groupMappedToReicoSite && !formulas.groupMappedToReicoSite.formulaEvaluationSuccess ||
                        formulas.groupMappedToDistributorSite && !formulas.groupMappedToDistributorSite.formulaEvaluationSuccess ||
                        formulas.code && !formulas.code.formulaEvaluationSuccess ||
                        formulas.name && !formulas.name.formulaEvaluationSuccess ||
                        formulas.active && !formulas.active.formulaEvaluationSuccess ||
                        formulas.startDate && !formulas.startDate.formulaEvaluationSuccess ||
                        formulas.endDate && !formulas.endDate.formulaEvaluationSuccess ||
                        formulas.showQuoteButton && !formulas.showQuoteButton.formulaEvaluationSuccess ||
                        formulas.showBuyButton && !formulas.showBuyButton.formulaEvaluationSuccess ||
                        formulas.hidePriceUntilCart && !formulas.hidePriceUntilCart.formulaEvaluationSuccess ||
                        formulas.minimumQty && !formulas.minimumQty.formulaEvaluationSuccess ||
                        formulas.maximumQty && !formulas.maximumQty.formulaEvaluationSuccess ||
                        formulas.inStockQuantity && !formulas.inStockQuantity.formulaEvaluationSuccess ?

                            <button className="btn btn-primary template publish hdr" disabled create={create ? "false" : "true"}>Publish</button>
                        :
                            <button className="btn btn-primary template publish hdr" create={create ? "false" : "true"} onClick={onRequestClose}>Publish</button>
                    }
                </div>
            </div>
        </Modal>
    );

// Modal.setAppElement('body');
        
export default CreateEditTemplate